import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';

export const STATUS_CONFIG = {
  open: { labelKey: 'open', bg: 'bg-red-100', text: 'text-red-700', dot: 'bg-red-500' },
  in_progress: { labelKey: 'inProgress', bg: 'bg-amber-100', text: 'text-amber-700', dot: 'bg-amber-500' },
  resolved: { labelKey: 'resolved', bg: 'bg-green-100', text: 'text-green-700', dot: 'bg-green-500' }
};

export const PRIORITY_CONFIG = {
  critical: { labelKey: 'critical', bg: 'bg-red-100', text: 'text-red-700' },
  high: { labelKey: 'high', bg: 'bg-orange-100', text: 'text-orange-700' },
  medium: { labelKey: 'medium', bg: 'bg-amber-100', text: 'text-amber-700' },
  low: { labelKey: 'low', bg: 'bg-blue-100', text: 'text-blue-700' }
};

export const SnagStatusBadge = ({ status }) => {
  const { t } = useLanguage();
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.open;
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${config?.bg} ${config?.text}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${config?.dot}`} />
      {t(config?.labelKey)}
    </span>
  );
};

export const SnagPriorityBadge = ({ priority }) => {
  const { t } = useLanguage();
  const config = PRIORITY_CONFIG?.[priority] || PRIORITY_CONFIG?.medium;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config?.bg} ${config?.text}`}>
      {t(config?.labelKey)}
    </span>
  );
};

export default SnagStatusBadge;
